import React, { useContext, useLayoutEffect, useRef, useState } from 'react'
import styles from "./registration.module.css"

import DateSection from './sections/dateSection'
import ServiceSection from './sections/serviceSection'
import TimePicker from './sections/timeSection'

import Button from '../button'
import { generateDate } from '../../utils/calendar'
import { notify } from '../toast'
import Modal from '../modal'
import SubmitPopUp from './sections/submit'
import { AuthContext } from '../../contextAPI'

const Registration = () => {

    const User = useContext(AuthContext)
    const {todays_day} = generateDate().filter(obj => obj.today)[0]
    const [selectedDay, setSelectedDay] = useState(todays_day)
    const [formatedDate, setFormatedDate] = useState(generateDate().filter(obj => obj.today)[0].date.format('DD/MM/YYYY'))
    const [selectedService, setSelectedService] = useState(null)
    const [selectedTime, setSelectedTime] = useState(null)
    const [isSubmited, setIsSubmited] = useState(false);
    
    const [weeksPerRow, setWeeksPerRow] = useState(1)

    const onDataClickHanlder = (date,formated) => {

        if(!date || !formated)return
        setSelectedDay(date)
        setFormatedDate(formated)
        setSelectedTime(null)

        const element = document.getElementById('services');
            element?.scrollIntoView({
            behavior: 'smooth'
        });

    }

    const container_ref = useRef(null);

    const onRegistrateHandler = () => {
        
        if(!selectedDay || !selectedService || !selectedTime)return notify("Pasirinkite datą, laiką bei paslaugą", "warning")

        setIsSubmited(true)
    }

    const row_weekdays_handler = () => {
        
        const currentWidth = container_ref.current ? container_ref.current.offsetWidth : 1;

        let number_of_slides = 3;
        if(currentWidth > 1600)number_of_slides = 4;
        if(currentWidth >= 1150 && currentWidth < 1400)number_of_slides = 3;
        if(currentWidth >= 880 && currentWidth < 1150)number_of_slides = 2;
        if(currentWidth < 880)number_of_slides = 1;
        setWeeksPerRow(number_of_slides);
    }

    useLayoutEffect(() => {
        row_weekdays_handler();
    });

    window.addEventListener("resize", () => {
        row_weekdays_handler();
    })
    
    return (
    <>
        <div id="registration" className={`${styles.container} ${""}`} ref={container_ref}>
            <h1 className={styles.main_header}>Registruokis jau dabar!</h1>
            <DateSection weeksPerRow={weeksPerRow} selected={selectedDay} todays_day={todays_day} onSelect={onDataClickHanlder} />
            <div id='services' className={styles.wrapper}>
                <ServiceSection onSelect={(obj)=>{setSelectedService(obj)}} />
                <TimePicker selectedService={selectedService} selectedDate={formatedDate} selectedTime={selectedTime} onSelect={(time) => {setSelectedTime(time)}} />
            </div>
            <Button onClick={onRegistrateHandler}>
                Rezervuotis
            </Button>
        </div>

        <Modal
            show={isSubmited}
            onClose={()=>setIsSubmited(false)}
        >
            <SubmitPopUp onClose={()=>setIsSubmited(false)} day={formatedDate} service={selectedService} time={selectedTime} />
        </Modal>
    </>
  )
}

export default Registration